<template>
  <div class="container">
      <div class="title0">
        <router-link :to="{path:'/'}"><img :src="url+'/img/xaiofei/sy.png'" class="return" /></router-link>
        <img :src="url+'/img/xaiofei/fh.png'" class="return" @click="clickReturn" />
        <img :src="url+'/img/zhibo/gx.png'" class="guang1" />
        <img :src="url+'/img/zhibo/gx.png'" class="guang2" />
      </div>
      <div class="content">
        <!-- 左侧导航 -->
        <!-- <div class="navBox">
          <div class="navLeft  animate__animated animate__fadeInLeft" :class="isShow? '' : 'left1'">
            <div :class="isShow? 'leftLeft' : 'leftLeft1'">
              <router-link :to="{path:'/xiaofei'}"><div class="btn btn2" ><span>电商直播</span></div></router-link>
              <router-link :to="{path:'/xiaofeiData'}"><div class="btn btn2"><span>电商大数据</span></div></router-link>
             <router-link :to="{path:'/xiaofeiChanpin'}"> <div class="btn btn1"><span>电商产品</span></div></router-link>
             <router-link :to="{path:'/zhibo'}"> <div class="btn btn2"><span>电商直播看板</span></div></router-link>
            </div>
            <img :src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/jt.png" class="jiantou" :class="!isShow?'jiantou1':''" @click="close" />
          </div>
        </div> -->
        <!-- 左侧 -->
        <div class="leftBox animate__animated animate__lightSpeedInLeft">
          <!-- <div class="contentLine contentLine1"></div>
          <div class="contentLine contentLine2"></div>
          <div class="contentLine contentLine3"></div>
          <div class="contentLine contentLine4"></div> -->
          <!--左一 -->
          <div class="leftBox1">
            <div class="title">电商产品价格趋势</div>
            <div class="leftcontent1">
              <div class="leftcontent1A">
                <div class="leftcontent1AItem" v-for="(item,index) in leftData1" :key="index">
                  <span>￥{{item.value}}</span>
                  <span>{{item.name}}</span>
                </div>
              </div>
              <div class="leftcontent1B">
                <div class="leftcontent1BItem" v-for="(item,index) in leftData2" :key="index">
                  <img :src="item.icon" />
                  <div class="itemRight"><span>{{item.name}}</span><span><i>{{item.value}}</i>吨</span></div>
                </div>
              </div>
            </div>
          </div>
          <!-- 左二 -->
          <div class="leftBox2">
            <div class="title">农资供应</div>
            <div class="leftcontent2">
              <div class="leftcontent2Item" v-for="(item,index) in leftData3" :key="index">
                <div class="iconBox">
                  <img :src="item.icon" />
                </div>
                <div class="font1">{{item.name}}</div>
                <div class="font2">{{item.value}}</div>
              </div>
            </div>
          </div>
          <div class="leftBox3">
            <router-link :to="{path:'/zhibo'}"><div class="title">产品销售趋势<img :src="url+'/img/jiantou.gif'" /></div></router-link>
            <div class="leftcontent3">
              <leftLine />
            </div>
          </div>
          
        </div> 
         <!--中间地图  -->
        <div class="center">
          <div class="centerTop">
            <div class="centerTopCon">
              <img :src="url+'/img/xaiofei/chanpin/dt.png'" />
              <div  :class="{'numB':item.isDb,'numA':!item.isDb,'num1':index==0,'num2':index==1,'num3':index==2,'num4':index==3,'num5':index==4,'num6':index==5,}" v-for="(item,index) in centerData1" :key="index">
                <span>{{index+1}}</span><span>{{item.num}}</span>
                <div class="centerContent  animate__animated animate__zoomIn" v-if="curCenterData1==index">
                  <h2>{{item.name}}</h2>
                  <div class="centerContentArr">
                    <div class="centerContentArrItem" v-for="(item0,index0) in item.arr" :key="index0">
                      <span>{{item0.name}}</span>
                      <span>{{item0.value}}{{item0.unit}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="centerBottom">
            <div class="title" style="width:100%">各乡镇农产品各项数据参考</div>
            <div class="centerBottomCon"><dv-scroll-board :config="config" style="width:100%;height:100%" /></div> 
          </div>
        </div>
        <!-- 右侧 -->
        <div class="rightBox animate__animated animate__lightSpeedInRight">
            <router-link :to="{path:'/XiaofeiData'}"><div class="title">整体产品交易数据<img :src="url+'/img/jiantou.gif'" /></div></router-link>
            <!-- 右一 -->
            <div class="rightBox1">
              <div class="subTit"><span></span>产品</div>
              <rightLine/>
            </div>
            <!-- 右二 -->
            <div class="rightBox2">
              <div class="subTit"><span></span>种植成本</div>
              <div class="rightContent2Box">
                <div class="rightLineABox">
                  <div class="rightLineA rightLineA1"></div>
                  <div class="rightLineA rightLineA2"></div>
                  <div class="rightLineB rightLineB1"></div>
                  <div class="rightLineB rightLineB2"></div>
                </div>
                <div class="rightLineBBox">
                  <div class="rightLineA rightLineA1"></div>
                  <div class="rightLineA rightLineA2"></div>
                  <div class="rightLineB rightLineB1"></div>
                  <div class="rightLineB rightLineB2"></div>
                </div>
                <div class="rightContent2">
                  <div class="square square1"></div>
                  <div class="square square2"></div>
                  <div class="square square3"></div>
                  <div class="square square4"></div>
                  <rightPie/>
              </div>
              </div> 
            </div>
            <!-- 右三 -->
            <div class="rightBox3">
              <div class="subTit"><span></span>供应信息展示</div>
                <div class="leftcontent1B">
                <div class="leftcontent1BItem" v-for="(item,index) in rightData2" :key="index">
                  <img :src="item.icon" />
                  <div class="itemRight"><span>{{item.name}}</span><span><i>{{item.value}}</i>吨</span></div>
                </div>
              </div>
              <div class="right3Data">
                <txtScroll>
                  <div v-for="item in rightData3" :key="item.id" class="scroll_item">
                    <div class="right3DataLeft">
                        <img :src="url+'/img/xaiofei/chanpin/rightIcon.png'" class="leftCircle" />
                        <div class="leftRight"><span>{{ item.name }}</span><span class="color">{{ item.total }}</span></div>
                    </div>
                    <div class="right3DataCenter color">XXXX</div>
                    <div class="right3DataRight color1">{{item.danjia}}/斤  {{item.num1}}斤</div>
                  </div>  
                </txtScroll>
              </div>
            </div>
        </div>
      </div>
  </div>
   <footer1 />
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import * as THREE from 'three';
import { useRouter } from 'vue-router'
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
// import waterimg from "@/assets/img/xaiofei/fk.png"


import leftLine from "../components/xiaofeiChanpin/leftLine.vue"
import rightLine from "../components/xiaofeiChanpin/rightLine.vue"
import rightPie from "../components/xiaofeiChanpin/rightPie.vue"
import txtScroll from "../components/xiaofeiChanpin/txtScroll.vue"
import footer1 from "../components/footer.vue";
export default {
  name: "Home",
  setup() {
    const router = useRouter();
    const { proxy } = getCurrentInstance();
    const timer = ref(null);
    const state = reactive({
      url:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      currentTime: "",
      isShow:false,
      leftData1:[
        {name:"玉米",value:"1.65"},
        {name:"小麦",value:"1.23"},
        {name:"高粱",value:"5.63"},
        {name:"辣椒",value:"30.36"},
        {name:"大豆",value:"2.61"},
        {name:"花生",value:"1.62"},
      ],
      leftData2:[{name:"产量",value:"1256",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/cl.gif'},{name:"售出量",value:"826",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/sc.png'}],
      leftData3:[{name:"供应商",value:"300",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/1.png'},{name:"投标单位",value:"345",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/2.png'},{name:"中标单位",value:"45",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/3.png'}],
      rightData2:[{name:"供应",value:"1256",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/gy.png'},{name:"求购",value:"826",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/qg.png'}],
      rightData3:[
        {name: '玉米批发',total:"20吨",danjia:"1.24",num1:400},
        {name: '玉米批发',total:"20吨",danjia:"1.24",num1:400},
        {name: '玉米批发',total:"20吨",danjia:"1.24",num1:400},
        {name: '玉米批发',total:"20吨",danjia:"1.24",num1:400},
        {name: '玉米批发',total:"20吨",danjia:"1.24",num1:400},
        {name: '玉米批发',total:"20吨",danjia:"1.24",num1:400},
        {name: '玉米批发',total:"20吨",danjia:"1.24",num1:400},
        {name: '玉米批发',total:"20吨",danjia:"1.24",num1:400},
        {name: '玉米批发',total:"20吨",danjia:"1.24",num1:400},
        {name: '玉米批发',total:"20吨",danjia:"1.24",num1:400},
    ],
    config:{
      header: ['乡镇', '产品名称', '产量', '售出时间', '售出', '综合排名'],
      data: [
        ['<span style="color:#17DBE0;">华陂镇</span>', '<span style="color:#17DBE0;">玉米</span>', '<span style="color:#17DBE0;">123</span>','<span style="color:#17DBE0;">2024-01-02</span>','<span style="color:#17DBE0;">1562</span>','<span style="color:#D4CB42;">3</span>'],
        ['<span style="color:#17DBE0;">无量寺乡</span>', '<span style="color:#17DBE0;">大豆</span>', '<span style="color:#17DBE0;">123</span>','<span style="color:#17DBE0;">2024-01-02</span>','<span style="color:#17DBE0;">1562</span>','<span style="color:#D4CB42;">3</span>'],
        ['<span style="color:#17DBE0;">塔桥镇</span>', '<span style="color:#17DBE0;">花生</span>', '<span style="color:#17DBE0;">123</span>','<span style="color:#17DBE0;">2024-01-02</span>','<span style="color:#17DBE0;">1562</span>','<span style="color:#D4CB42;">3</span>'],
        ['<span style="color:#17DBE0;">邵店乡</span>', '<span style="color:#17DBE0;">黑豆</span>', '<span style="color:#17DBE0;">123</span>','<span style="color:#17DBE0;">2024-01-02</span>','<span style="color:#17DBE0;">1562</span>','<span style="color:#D4CB42;">3</span>'],
        ['<span style="color:#17DBE0;">五龙镇</span>', '<span style="color:#17DBE0;">小麦</span>', '<span style="color:#17DBE0;">123</span>','<span style="color:#17DBE0;">2024-01-02</span>','<span style="color:#17DBE0;">1562</span>','<span style="color:#D4CB42;">3</span>'],
        ['<span style="color:#17DBE0;">蔡沟镇</span>', '<span style="color:#17DBE0;">玉米</span>', '<span style="color:#17DBE0;">123</span>','<span style="color:#17DBE0;">2024-01-02</span>','<span style="color:#17DBE0;">1562</span>','<span style="color:#D4CB42;">3</span>'],
       
      ],
      headerBGC:"rgba(0,67,92,.6)",
      oddRowBGC:"rgba(0,67,92,.4)",
      evenRowBGC:"rgba(0,67,92,.2)",
      // index: true,
      columnWidth: [],
      align: ['center'],
      // rowNum:6
    },
    centerData1:[
      {name:"华陂镇",num:89098,isDb:true,arr:[
        {name:"供应商",value:98,unit:"家"},
        {name:"农产品",value:5981,unit:"吨"},
        {name:"售出量",value:298,unit:"吨"},
        {name:"批发量",value:198,unit:"吨"},
        {name:"收入总值",value:98,unit:"元"},
      ]},
      {name:"无量寺乡",num:5269,isDb:true,arr:[
        {name:"供应商",value:98,unit:"家"},
        {name:"农产品",value:5981,unit:"吨"},
        {name:"售出量",value:298,unit:"吨"},
        {name:"批发量",value:198,unit:"吨"},
        {name:"收入总值",value:98,unit:"元"},
      ]},
      {name:"塔桥镇",num:9756,isDb:false,arr:[
        {name:"供应商",value:98,unit:"家"},
        {name:"农产品",value:5981,unit:"吨"},
        {name:"售出量",value:298,unit:"吨"},
        {name:"批发量",value:198,unit:"吨"},
        {name:"收入总值",value:98,unit:"元"},
      ]},
      {name:"邵店乡",num:7569,isDb:true,arr:[
        {name:"供应商",value:98,unit:"家"},
        {name:"农产品",value:5981,unit:"吨"},
        {name:"售出量",value:298,unit:"吨"},
        {name:"批发量",value:198,unit:"吨"},
        {name:"收入总值",value:98,unit:"元"},
      ]},
      {name:"五龙镇",num:3658,isDb:true,arr:[
        {name:"供应商",value:98,unit:"家"},
        {name:"农产品",value:5981,unit:"吨"},
        {name:"售出量",value:298,unit:"吨"},
        {name:"批发量",value:198,unit:"吨"},
        {name:"收入总值",value:98,unit:"元"},
      ]},
      {name:"蔡沟镇",num:5469,isDb:false,arr:[
        {name:"供应商",value:98,unit:"家"},
        {name:"农产品",value:5981,unit:"吨"},
        {name:"售出量",value:298,unit:"吨"},
        {name:"批发量",value:198,unit:"吨"},
        {name:"收入总值",value:98,unit:"元"},
      ]},
    ],
     curCenterData1:0
    });
    onMounted(() => {
      setInterval(()=>{
        let centerData1 = state.centerData1
          if(state.curCenterData1==0||state.curCenterData1<centerData1.length-1){
            state.curCenterData1++
          }else{
            state.curCenterData1=0
          }
      },3000)
      

    })
    onUnmounted(() => {
      // 清理资源

    });
    onBeforeUnmount(() => {
      clearInterval(timer.value);
    })
 // 返回上一页
    function clickReturn(){
        router.go(-1);
    }
   
    function close(){
      state.isShow=!state.isShow
    }

    return {
      ...toRefs(state),
      close,
      clickReturn
      
    };
  },
  components: {
      leftLine,
      rightLine,
      rightPie,
      txtScroll,
      footer1
  },
};
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/font/DS-DIGIT.TTF");
}
a{
  color: #fff;
}
.container{
  width: 100%;
  height: 100%;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/bj.jpg") no-repeat top center;
  background-size: 100% 100%;
  color: #fff;
  position: relative;
  overflow: hidden;
  .title0{
    width: 100%;
    height: 81px;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/bt.png") no-repeat top center;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .return{
      width: 81px;
      height: 38px;
      cursor: pointer;
      margin-right: 50px;
      margin-top: 26px;
      position: relative;
      z-index: 999;
    }
    .return:first-child{
      margin-left: 50px;
    }
    .guang1{
      position: absolute;
      top: -34px;
      left: 0;
      animation: titleGuang1 2s linear infinite;
      z-index: 0;
    }
    .guang2{
      position: absolute;
      top: -34px;
      right: 0;
      animation: titleGuang2 2s linear infinite;
    }
    @keyframes titleGuang1{
      0%{
        left: 0;
      }
      100%{
        left: 15%;
      }
    }
    @keyframes titleGuang2{
      0%{
        right: 0;
      }
      100%{
        right: 15%;
      }
    }
  }
  .content{
    width: 100%;
    height: calc(100% - 81px);
    display: flex;
    position: relative;
    padding: 20px 50px;
    box-sizing: border-box;
    .navBox{
      position: absolute;
      left: 0;
      top: 0;
      width: 320px;
      height: 100%;
      z-index: 999;
      .navLeft{
        width: 320px;
        height: 100%;
        padding-right: 120px;
        display: flex;
        align-items: center;
        // justify-content: center;
        box-sizing: border-box;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/dh.png") no-repeat top center ;
        background-size: 100% 100%;
         position: relative;
         transition: all 1s ease-out;
        .leftLeft{ 
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
          transition: all 1s ease-out;
          .btn{
            width: 147px;
            height: 53px;
            text-align: center;
            line-height: 53px;
            margin: 30px 0 0 0;
            font-size: 16px;
            cursor: pointer;
            transition: all 1s ease-out;
            animation: bianda 1s linear infinite;
            position: relative;
            span{
              position: absolute;
              top: 0;
              left: 0;
              display: block;
              width: 100%;
              height: 100%;

            }
          }
          .btn1,.btn:hover{
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/xz.png") no-repeat top center;
            color: #DBD600;
          }
          .btn2{
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/wxz.png") no-repeat top center;
            color: #9FEFEE;
          }
          .btn1:hover{
            position: relative;
            animation-play-state:paused;
            margin-bottom: 30px;
          }
        }
      .jiantou{
        width: 76px;
        height: 127px;
        position: absolute;
        right: 90px;
        animation: jiantou 1s linear infinite;
        cursor: pointer;
      }
      .jiantou1{
        transform: rotate(180deg);
      }
    }
    .left1{
      width: 160px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/dh.png") no-repeat center right;
      transition: all 1s ease-out; 
    }
    .leftLeft1{
      width: 0;
      overflow: hidden;
      .btn{width: 0;}
    }
    }
    .leftBox,.rightBox{
      width: 399px;
      height: 100%;
      padding: 12px 12px 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      height: 100%;
      background: rgba(4,45,66,.4);
      position: relative;
      overflow: hidden;
    }
    .leftBox{
      .leftBox1,.leftBox2,.leftBox3{
        display: flex;
        flex-direction: column;
      }
      .leftBox1{
        width: 100%;
        height: 310px;
        .leftcontent1{
          flex: 1;
          .leftcontent1A{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .leftcontent1AItem{
              width: 113px;
              height: 80px;
              margin:5px;
              background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/xk.png") no-repeat;
              background-size: 100% 100%!important;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              font-size: 14px;
              line-height: 24px;
              position: relative;
              overflow: hidden;
              span:first-child{
                color: #14955C;
                font-weight: bold;
                font-size: 15px;
              }
            }
          }
        } 
      }
      .leftBox2{
        width: 100%;
        height: 230px;
        //  border: 1px solid;
        .leftcontent2{
          display: flex;
          justify-content: space-between;
          margin-top: 10px;
          .leftcontent2Item{
            width: 117px;
            height: 161px;
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/ck.png") no-repeat;
            background-size: 100% 100%!important;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            .iconBox{
              width: 83px;
              height: 90px;
              background-size: 100% 100%!important;
              display: flex;
              justify-content: center;
              align-items: center;
              animation: bianda 1s linear infinite;
              img{
                width: 37px;
                height: 37px;
              }
            }
            .font2{
              margin: 4px 0;
            }
          }
          .leftcontent2Item:nth-child(1){
            .iconBox{
              background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/L.png") no-repeat ;
            }
            .font2{
              color: #12ACB4;
            }
          }
          .leftcontent2Item:nth-child(2){
            .iconBox{
              background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/lS.png") no-repeat ;
            }
            .font2{
              color: #12ACB4;
            }
          }
          .leftcontent2Item:nth-child(3){
            .iconBox{
              background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/h.png") no-repeat ;
            }
            .font2{
              color: #FCCE4A;
            }
          }
        }
      }
      .leftBox3{
        width: 100%;
        flex: 1;
        .leftcontent3{
          width: 100%;
          flex: 1;
        }
      }
      
    }
    
    .center{
      flex: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 0 30px;
      .centerTop{
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        .centerTopCon{
          width: 707px;
          height: 471px;
          position: relative;
          font-size: 14px;
          .numA,.numB{
            width:131px ;
            height: 47px;
            background-size: 100% 100%;
            position: absolute;
            text-align: center;
            line-height: 47px;
            display: flex;
            justify-content: space-between;
            padding: 0 25px;
            box-sizing: border-box;
            span{
              display: block;
            }
            span:first-child{
              width: 19px;
              height: 19px;
              text-align: center;
              line-height: 19px;
              margin: 14px 10px 0 0;
              border-radius: 50%;
            }
            span:last-child{
              font-size: 16px;
            }
          }
          .numA{
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/hk.png") no-repeat ;
            span:first-child{
              background-image: linear-gradient(to top, #F2730D 0%, #F1BE38 100%);
            }
          }
          .numB{
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/lk.png") no-repeat ;
            span:first-child{
              background-image: linear-gradient(to top, #0580E6 0%, #36BCEF 100%);
            }
          }
          .num1{
            top: 60px;
            left: 120px;
          }
          .num2{
            top: 230px;
            left: 30px;
          }
          .num3{
            top: 160px;
            left: 280px;
          }
          .num4{
            top: 360px;
            left: 130px;
          }
          .num5{
            bottom: 80px;
            right: 280px;
          }
          .num6{
            bottom: 160px;
            right: 40px;
          }
          .centerContent{
            width: 326px;
            height: 333px;
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/fdk.png") no-repeat ;
            position: absolute;
            top:17px;
            left: -318px;
            z-index: 999;
            padding: 124px 50px 100px;
            box-sizing: border-box;
            h2{
              text-align: center;
              font-size: 16px;
              line-height: 30px;
            }
            .centerContentArr{
              width: 100%;
              line-height: 26px;
              .centerContentArrItem{
                display: flex;
                justify-content: space-between;
                align-items: center;
                overflow: hidden;
                position: relative;
                padding-left: 10px;
                span{
                  flex: 1;
                  display: block;
                  background: none;
                  margin: 0;
                  font-size: 14px;
                  text-align: left;
                }
              }
              .centerContentArrItem::before{
                position: absolute;
                top:10px;
                left: 0;
                display: block;
                content: "";
                width: 6px;
                height: 6px;
                background: #27FFE8;
                border-radius: 50%;
                box-shadow: 0 3px 2px rgba(255, 255, 255, .2);
              }
            }
            
          }
        }
      }
      .centerBottom{
        width: 100%;
        height: 266px;
        background: rgba(4,45,66,.4);
        padding: 10px 10px 10px;
        margin-bottom: 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        .centerBottomCon{
          width: 100%;
          flex: 1;
          margin-top: 10px;
        }
      }
      
    }
    // 右
    .rightBox{
      .subTit{
        display: flex;
        color: #00CCFF;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        span{
          display: block;
          width: 4px;
          height: 15px;
          background: #00CCFF;
          margin: 12px 10px 0 0;
        }
      }
      .rightBox1,.rightBox3{
        flex: 1;
        display: flex;
        flex-direction: column;

      }
      .rightBox2{
        height: 220px;
        display: flex;
        flex-direction: column;
      }
      .rightBox2{
        .rightContent2Box{
            padding: 5px 10px;
            // width: 100%;
            flex: 1;
            position: relative;
            box-sizing: border-box;
            .rightLineABox{
              position: absolute;
              width: 100%;
              height: 2px;
              z-index: 999;
              left: 0;
              top: 0;
              .rightLineA1{
                top: -3px;
                left: -2px;
              }
              .rightLineA2{
                top: -3px;
                right: -2px;
              }
              .rightLineB{
                  width:2px;
                  height: 10px;
                  background: #026677;
                  position: absolute;
                }   
              .rightLineB1{
                top: -3px;
                left: -2px;
              }
              .rightLineB2{
                top: -3px;
                right: -2px;
              }
            }
            .rightLineBBox{
              position: absolute;
              width: 100%;
              height: 2px;
              z-index: 999;
              left: 0;
              bottom: 0;
              .rightLineA1{
                bottom: -3px;
                left: -2px;
              }
              .rightLineA2{
                bottom: -3px;
                right: -2px;
              }
              .rightLineB{
                  width:2px;
                  height: 10px;
                  background: #026677;
                  position: absolute;
                }   
              .rightLineB1{
                bottom: -3px;
                left: -2px;
              }
              .rightLineB2{
                bottom: -3px;
                right: -2px;
              }
            }
            .rightLineA{
                width:10px;
                height: 100%;
                background: #026677;
                position: absolute;
              }   
          .rightContent2{
            width: 100%;
            height: 100%;
            box-shadow: inset 0 0 5px 1px rgba(55, 199, 219, .5);
            box-sizing: border-box;
            position: relative;
            .square{
              width: 4px;
              height: 4px;
              background: #00CCFF;
              position: absolute;
            }
            .square1{
              top: 0;
              left: 0;
            }
            .square2{
              top: 0;
              right: 0;
            }
            .square3{
              bottom: 0;
              left: 0;
            }
            .square4{
              bottom: 0;
              right: 0;
            } 
        }
        }
        
      }
      // 右三
      .rightBox3{
        .right3Data{
          width: 100%;
          flex: 1;
          .scroll_item {
            // height: 44px;
            margin-bottom: 10px;
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            line-height: 22px;
            .color{
                color: #448F94;
            }
            .color1{
                color: #18E69C;
            }
            .right3DataLeft{
                display: flex;
                .leftCircle{
                    width: 16px;
                    height: 17px;
                    margin: 1px 5px 0 0;
                }
                .leftRight{
                    text-align: left;
                    span{
                        display: block;
                    }
                }
            }
          }
        }
      }
      
     
      
    }
    // 标题
    .title{
      width: 100%;
      height: 43px;
      line-height: 46px;
      text-align: left;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/chanpin/xbt.png") no-repeat ;
      font-size: 16px;
      text-shadow: 0 0 8px #32D1DA;
      font-style: italic;
      letter-spacing: 2px;
      padding-left: 60px;
      box-sizing: border-box;
      animation: title 3s linear infinite;
      display: flex;
      justify-content: space-between;
      position: relative;
      img{
        height: 12px;
        margin-right: 20px;
        margin-top: 15px;
      }
    }
    .leftcontent1B{
      display: flex;
      justify-content: space-between;
      .leftcontent1BItem{
        width: 163px;
        height: 74px;
        margin: 5px;
        box-shadow: inset 0 0 5px 2px rgba(55, 199, 219, .5);
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        animation: leftJx 1s linear infinite;
        img{
          width: 46px;
          height: 44px;
          margin-right: 8px;
        }
        .itemRight{
          display: flex;
          flex-direction: column;
          font-size: 12px;
          text-align: left;
          span{
            display: block;
            line-height: 22px;
            font-size: 12px;
          }
          span:last-child i{
            color: #14955C;
            margin-right: 5px;
            font-size: 16px;
            font-style: normal;
          }
        }
      }
    }
  }
}
@keyframes title {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      background-position: 0 0;
  } 
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  50%{
    background-position: 10px 0;
  }
   100%{
    background-position: 0 0;
  }
}
@keyframes bianda {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      // transform: scale(0.96);
      filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  } 
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  50%{
    // transform: scale(1);
    filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.5));
  }
   100%{
    // transform: scale(0.96);
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  }
}
@keyframes jiantou {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      right: 90px;
  } 
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  50%{
    right: 95px;
  }
   100%{
    right: 90px;
  }
}
/* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
  0% {
          transform: rotate(0deg);
      }

  100% {
      transform: rotate(360deg);
  }
}
// 左侧矩形
@keyframes leftJx {    /*引用动画名称*/
  0% {
          box-shadow: inset 0 0 5px 2px rgba(55, 199, 219, .5);
      }
  50% {
        box-shadow: inset 0 0 10px 2px rgba(55, 199, 219, .5);
    }

  100% {
      box-shadow: inset 0 0 5px 2px rgba(55, 199, 219, .5);
  }
}



  .contentLine {
      background: #AA6A1C;
      position: absolute;
    }
   .contentLine1{
      top: 0;
      left: 0;
      width: 20%;
      height: 2px;
      /* 加上渐变效果，方可形成拖尾效果 */
      background: linear-gradient(90deg, transparent, #1AA19E);
      animation: animate1 4s linear infinite;
    }
    .contentLine2{
      top: -100%;
      right: 0px;
      width: 2px;
      height: 20%;
      background: linear-gradient(180deg, transparent, #1AA19E);
      animation: animate2 4s linear infinite;
      /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
      animation-delay: 1s;
    }
    .contentLine3{
      bottom: 0;
      right: 0;
      width: 20%;
      background: linear-gradient(270deg, transparent, #1AA19E);
      animation: animate3 4s linear infinite;
      animation-delay: 2s;
    }
    .contentLine4{
      bottom: -100%;
      left: 0px;
      width: 2px;
      height: 20%;
      background: linear-gradient(360deg, transparent, #1AA19E);
      animation: animate4 4s linear infinite;
      animation-delay: 3s;
    }
  
@keyframes animate1 {
    0% {
        left: -50%;
    }

    50%,
    100% {
        left: 100%;
    }
}
@keyframes animate2 {
    0% {
        top: -100%;
    }

    50%,
    100% {
        top: 100%;
    }
}
@keyframes animate3 {
    0% {
        right: -100%;
        height: 3px;
    }

    50%,
    100% {
        height: 2px;
        right: 100%;
    }
}
 @keyframes animate4 {
    0% {
        bottom: -100%;
    }

    50%,
    100% {
        bottom: 100%;
    }
}
</style>
